export default __webpack_public_path__ + "static/media/drag.183761a6.svg";